<footer class="text-center text-lg-start">

	<section class="p-4 text-white" *ngIf="showAll">
	  <div class="container text-center text-md-start mt-5">
		<div class="row mt-3">
		  	<div class="col-md-3 mx-auto mb-4">
				<img id="footer-logo" src="/assets/img/memorabid-logo-white.svg" alt="Logo" class="img-fluid mb-4">

				<div class="d-flex justify-content-center p-4">
					<a *ngIf="appSettings.urlInstagram" href="{{appSettings.urlInstagram}}" target="_blank" class="me-4 text-reset">
						<fa-icon [icon]="faInstagram"></fa-icon>
					</a>
					<a *ngIf="appSettings.urlFacebook" href="{{appSettings.urlFacebook}}" target="_blank" class="me-4 text-reset">
						<fa-icon [icon]="faFacebookF"></fa-icon>
					</a>
					<a *ngIf="appSettings.urlTiktok" href="{{appSettings.urlTiktok}}" target="_blank" class="me-4 text-reset">
						<fa-icon [icon]="faTikTok"></fa-icon>
					</a>
					<a *ngIf="appSettings.urlTwitter" href="{{appSettings.urlTwitter}}" target="_blank" class="me-4 text-reset">
						<fa-icon [icon]="faTwitter"></fa-icon>
					</a>
					<a *ngIf="appSettings.urlLinkedin" href="{{appSettings.urlLinkedin}}" target="_blank" class="text-reset">
						<fa-icon [icon]="faLinkedinIn"></fa-icon>
					</a>
			  	</div>
				<span class="payments-available mb-1 mt-3">{{"IDS_AVAILABLE_PAYMENTS" | translate}}</span>
				<!-- <div class="d-flex justify-content-center align-items-center ps-4 pe-4 pb-4">
					<fa-icon [icon]="faCcPaypal" size="lg" class="me-1"></fa-icon>
					<fa-icon [icon]="faCcVisa" size="lg" class="me-1"></fa-icon>
					<fa-icon [icon]="faCcMastercard" size="lg" class="me-1"></fa-icon>
					<fa-icon [icon]="faCcAmex" size="lg" class="me-1"></fa-icon>
					<fa-icon [icon]="faCcApplePay" size="lg" class="me-1"></fa-icon>
          <span class="me-1 bg-gray">
            <fa-icon [icon]="faGooglePay" size="lg" class="tr-2"></fa-icon>
          </span>
				</div> -->
        <img height="40px" src="/assets/img/payments-footer.png" alt="payments" />
				<!-- <span *ngIf="appSettings.urlAppAndroid && appSettings.urlAppIos" class="download-app mb-1">{{"IDS_DOWNLOAD_APP" | translate}}</span>
				<span *ngIf="!appSettings.urlAppAndroid && !appSettings.urlAppIos" class="download-app mb-1">{{"IDS_APP_SOON" | translate}}</span>
				<div *ngIf="appSettings.urlAppAndroid && appSettings.urlAppIos" class="d-flex justify-content-center ps-4 pe-4 pb-4">
					<a href="{{appSettings.urlAppAndroid}}" target="_blank" class="text-reset me-1">
						<img src="/assets/img/play-store.png" class="store-logo" alt="play-store">
					</a>
					<a href="{{appSettings.urlAppIos}}" target="_blank" class="text-reset">
						<img src="/assets/img/app-store.png" class="store-logo" alt="app-store">
					</a>
				</div>
				<div *ngIf="!appSettings.urlAppAndroid && !appSettings.urlAppIos" class="d-flex justify-content-center ps-4 pe-4 pb-4">
					<a class="text-reset link-app me-1">
						<img src="/assets/img/play-store.png" class="store-logo" alt="play-store">
					</a>
					<a class="text-reset link-app">
						<img src="/assets/img/app-store.png" class="store-logo" alt="app-store">
					</a>
				</div> -->
		  	</div>

			<div *ngIf="pagesCol1 != null" class="col-md-3 mx-auto mb-4">
				<div class="footer-page-link" *ngFor="let page of pagesCol1[0].pageGroupList;">
					<a [routerLink]="page.languagePath">
						{{ page.idsPageName | translate }}
					</a>
				</div>
			</div>

			<div *ngIf="pagesCol2 != null" class="col-md-3 mx-auto mb-4">
				<h6 class="certificate-validation">
					<button class="text-reset cert-button" type="button" (click)="certificateDialog()">{{"IDS_CERTIFICATE_VALIDATE" | translate}}</button>
				</h6>
				<h6 class="nameBecomeSeller">
					<a routerLink="become-seller" class="text-reset">{{"IDS_BECOME_SELLER" | translate}}</a>
				</h6>
				<h6 class="text-uppercase mb-3">
					<hr class="hr-footer">
					<!--{{ pagesCol2[0].idsGroupName | translate }}-->
				</h6>
				<div class="footer-page-link" *ngFor="let page of pagesCol2[0].pageGroupList;" >
					<a class="iubenda-cs-preferences-link" *ngIf="page.idsPageName==='IDS_COOKIE_POLICY'">
						{{ page.idsPageName | translate }}
					</a>
					<a [routerLink]="page.pageRoute" *ngIf="page.idsPageName!=='IDS_COOKIE_POLICY'">
						{{ page.idsPageName | translate }}
					</a>
				</div>
			</div>

		<div class="col-md-3 mx-auto mb-4">
			<h6 class="text-uppercase mb-3">
				{{"IDS_NEWSLETTER" | translate}}
			</h6>
			<form (ngSubmit)="onSubmit(newsletterForm)" #newsletterForm="ngForm" autocomplete="off">
				<p class="text-muted mb-4">{{"IDS_NEWSLETTER_UPDATE" | translate}}</p>
				<input type="text" placeholder="Email" name="email" id="email" [(ngModel)]="email" required>
				<label class="text-muted label-container text-privacy">
					<input class="input-checkbox" type="checkbox" checked="checked" name="subscribe" required> {{"IDS_ACCEPT" | translate}} <a class="privacy-policy" (click)="goToPage('privacy-policy')">Privacy Policy</a>
					<span class="checkmark"></span>
				</label>
				<div>
					<button class="text-uppercase fw-bold" type="submit" [disabled]="!newsletterForm.valid">{{"IDS_SUBSCRIBE" | translate}}</button>
				</div>
			</form>
		</div>
		</div>
	</div>
	</section>

    <div class="row p-0 m-0" *ngIf="!showAll">
        <div class="col-2 p-0 m-0"></div>
        <div class="col-8 logo-img px-3 py-5 m-0">
            <img src="/assets/img/memorabid-logo-white.svg" alt="Logo">
        </div>
        <div class="col-2 p-0 m-0"></div>
    </div>

	<div class="info-bottom text-center p-4 text-muted" [class.bottom-space]="!showAll">
		<p>
			<small>Memorabid | {{"IDS_RIGHTS" | translate}}<br/>
			Memorabid Srl - Via Caldera 21, Regus, Easypoint (Building F), 20153 Milano - C.F./P.IVA {{appSettings.taxId}}<br/>
			{{"IDS_BUSINESS_REGISTER" | translate}} {{appSettings.businessRegisterCode}} - {{"IDS_SHARE_CAPITAL" | translate}}{{appSettings.socialCapital}} €
			</small>
		</p>
	</div>
</footer>
